import React from 'react';
import { Tooltip, Avatar } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const LightTooltip = withStyles({
  tooltip: {
    backgroundColor: "white",
    border: "1px solid lightgrey",
    color: "#333",
    minWidth: "320px"
  }
})(Tooltip);
const PeopleCardEntity = ({ peopleCardEntity }) => {
  return /* @__PURE__ */ React.createElement(LightTooltip, { title: peopleCardEntity.name }, /* @__PURE__ */ React.createElement("a", { href: peopleCardEntity.web_url, target: "_blank" }, /* @__PURE__ */ React.createElement(
    Avatar,
    {
      key: peopleCardEntity.name,
      alt: peopleCardEntity.name,
      src: peopleCardEntity.avatar_url
    }
  )));
};

export { PeopleCardEntity };
//# sourceMappingURL=PeopleCardEntity.esm.js.map
